/**
 * Analytics helper — fires events to both GA4 (window.gtag) and Microsoft Clarity (window.clarity).
 * Safe no-op if either is blocked by an ad-blocker or hasn't loaded yet.
 */

export function track(eventName, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }
  } catch (e) { /* swallow */ }
  try {
    if (typeof window !== "undefined" && typeof window.clarity === "function") {
      window.clarity("set", eventName, JSON.stringify(params).slice(0, 200));
    }
  } catch (e) { /* swallow */ }
}

// Common events
export const trackQuoteSubmitted = (service) => {
  track("generate_lead", { event_category: "engagement", service, value: 1 });
  track("quote_submitted", { service });
};

export const trackPhoneClick = (location) =>
  track("phone_click", { event_category: "engagement", location });

export const trackReviewClick = () =>
  track("google_review_click", { event_category: "engagement" });

export const trackCallNow = (location) =>
  track("call_now_click", { event_category: "cta", location });

export const trackQuoteCTA = (location) =>
  track("quote_cta_click", { event_category: "cta", location });
